// app/providers.tsx

import { ToastProvider } from "@heroui/toast";

export default function HeroUIToastProvider({ children }) {
    return (
        <>
            <ToastProvider ></ToastProvider>
            {children}
        </>
    )
}